<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <c-card title="Crear perfil">
          <profile-form />
        </c-card>
      </div>
    </div>
  </div>
</template>
<script>
import ProfileForm from "@/components/Forms/ProfileForm.vue";
import CCard from "@/components/CCard.vue";
export default {
  components: {
    ProfileForm,
    CCard,
  },
};
</script>
